import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  html {
    height: 100%;
}

  body {
    font-family: 'Inter', sans-serif;
    font-size: 100%; // 1rem = 16px
    box-sizing: border-box;
  }
  
  input, textarea, button {
    font-family: inherit;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh; 

    &.green-bg {
      background-color: #25763C12;
    }
  }

  .leaflet-container {
    font-family: 'Inter', sans-serif;
  }

  .section-map-circle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;
    color: #25763C;
  }

`;

export default GlobalStyles;
